export default __webpack_public_path__ + "static/media/tw.ef2a642f.svg";